<template>
    <edit-resource :form="form" :title="title" @close="$emit('close')" @submit="handleSubmit">
        <div class="w-768">
                <siu
                    v-model="form.header_path_queued_id"
                    :image="headerImageUrl"
                    :min-height="600"
                    :min-width="1500"
                    classes="h-244 w-full rounded mb-24"
                    icon-location="corner"
                    ratio="4:1,3"
                    @clear="clearImg"
                    @success="resetImg"
                />

            <div>
                <translatable #default="{ languages, selectedLanguage }" :errors="warningTabs">
                    <div v-for="lang in languages" :key="lang" class="flex">
                        <simple-input
                            v-show="lang === selectedLanguage"
                            ref="title"
                            v-model="form.companypage_header1[lang]"
                            class="w-1/2 mr-32"
                        >
                            {{ $t('site_editor.header.title') }}
                            <span v-if="languages.length > 1">({{ lang }})</span>
                        </simple-input>

                        <simple-input
                            v-show="lang === selectedLanguage"
                            v-model="form.header_caption[lang]"
                            class="w-1/2"
                        >
                            {{ $t('site_editor.header.subtitle') }}
                            <span v-if="languages.length > 1">({{ lang }})</span>
                        </simple-input>
                    </div>
                </translatable>
            </div>
        </div>
    </edit-resource>
</template>

<script>
import PopupModal from './PopupModal.vue';
import SvgIcon from './SvgIcon.vue';
import EditResource from './EditResource.vue';
import Input from '../forms/Input.vue';
import Translatable from '../forms/Translatable.vue';
import SimpleButton from '../ui/SimpleButton.vue';
import Form from '../../etc/forms/Form';
import SingleImageUpload from '../forms/SingleImageUpload.vue';
import * as jobsites from '../../services/JobsiteService';
import Jobsite from '../../models/Jobsite';
import {normalizeJson} from '../../../shared/helpers';
import {mapState, mapActions} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../state/store';
import {useBrandingStore} from '../../../shared/state/branding';


export default {
    components: {
        'popup-modal': PopupModal,
        'svg-icon': SvgIcon,
        'edit-resource': EditResource,
        'simple-input': Input,
        'translatable': Translatable,
        'siu': SingleImageUpload,
        'simple-button': SimpleButton,
    },
    setup()  {
        const mainStore = useMainStore();
        return {mainStore};
    },
    data: function () {
        return {
            form: this.generateForm(),
        };
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
        title() {
            return this.$t('site_editor.header.editor_title');
        },
        headerImageUrl() {
            return this.currentCompany.jobsite.header_url;
        },
        warningTabs() {
            let languages = this.currentCompany.jobsite.active_languages;
            let errorLang = [];

            for (let index in languages) {
                if (!this.form.data.companypage_header1[languages[index]]) {
                    errorLang.push(languages[index]);
                }
            }
            return errorLang;
        },
    },
    methods: {
        ...mapActions(useBrandingStore, [ 'stopConfiguringHeader', 'cancelConfiguringHeader' ]),
        getFields() {
            return [
                {
                    name: 'companypage_header1',
                    value: this.mainStore.currentCompany.jobsite.companypage_header1,
                },
                {
                    name: 'header_caption',
                    value: this.mainStore.currentCompany.jobsite.header_caption,
                },
                {name: 'header_path', value: 'default'},
                {name: 'header_path_queued_id', value: null},
            ];
        },
        generateForm() {
            return new Form(this.getFields());
        },
        close() {
            this.$emit('close');
        },
        async handleSubmit() {
            if (this.form.data.header_path === 'default') {
                delete this.form.data.header_path;
            }

            await this.form.submit(data => {
                return jobsites.update(this.currentCompany.id, {data: {attributes: data}});
            }).then(result => {
                return useRepo(Jobsite).save(normalizeJson(result));
            });

            this.stopConfiguringHeader();
        },
        clearImg() {
            this.form.data.header_path = null;
        },
        resetImg() {
            this.form.data.header_path = 'default';
        },
    },
};
</script>
